export default __webpack_public_path__ + "static/media/case-alert.212f9282.svg";